import "./Switch.css";
import React from "react";

const AISwitch = ({ onChange, value }) => {
  const activeValue = value || "CLASSIC";

  const handleChange = (nextValue) => {
    if (nextValue !== activeValue && onChange) {
      onChange(nextValue);
    }
  };

  return (
    <div className="ai-switch">
      <button
        type="button"
        onClick={() => handleChange("CLASSIC")}
        className={`ai-switch-option ${activeValue === "CLASSIC" ? "ai-switch-selected" : ""}`}
      >
        Classic
      </button>

      <button
        type="button"
        onClick={() => handleChange("NEW")}
        className={`ai-switch-option ${activeValue === "NEW" ? "ai-switch-selected" : ""}`}
      >
        New
        <span className="ai-switch-label">New</span>
      </button>
    </div>
  );
};

export default AISwitch;
